import { InactiveServiceRepWindow } from "src/internal/types/inactiveServiceRepWindow";
import { CommunicationPreferencesType } from "./customerPrefs";
import { SystemRole } from "src/internal/types/authentication";
import { Branch } from "./branch";

export class EmployeeRole {
  branchId: number;
  role: SystemRole;
}

export class RepresentativeBranchReason {
  branchId: number;
  reasonId: number;
}

export class Representative {
  constructor() {
    this.userId = -1;
    this.description = "";
    this.source = 0;
    this.sourcePersonId = "";
    this.email = "";
    this.firstName = "";
    this.id = -1;
    this.imageUrl = "";
    this.inactiveWindows = [];
    this.isCustomerVisible = false;
    this.isEmailFromDna = false;
    this.isEmailValid = false;
    this.isActive = false;
    this.lastName = "";
    this.name = "";
    this.notificationPreference = "EMAIL";
    this.phone = "";
    this.branchReasons = [];
    this.skypeId = "";
    this.thumbnailUrl = "";
    this.region = "";
    this.roles = [];
    this.branches = [];
  }

  userId?: number;
  description: string;
  source: number;
  sourcePersonId?: string;
  email?: string;
  isEmailValid?: boolean;
  isEmailFromDna?: boolean;
  isActive: boolean;
  firstName: string;
  id: number;
  imageUrl: string;
  lastName: string;
  name: string;
  phone: string;
  branchReasons: RepresentativeBranchReason[];
  skypeId: string | null;
  inactiveWindows: InactiveServiceRepWindow[];
  thumbnailUrl?: string;
  isCustomerVisible: boolean;
  notificationPreference: CommunicationPreferencesType;
  region: string;
  roles: EmployeeRole[];
  branches: Branch[];
}

export const repBelongsToBranch = (rep: Representative, branchId: number) => {
  return rep.branches.some(br => br.id === branchId);
};
